export default __webpack_public_path__ + "c499070ef4e10a1bcad16dc714d15ef3.svg";